import Account from './Account';
import Resources from './Resource';
import Link from './Link';

class AuditLog {
  eventTime;

  account = new Account();

  eventName;

  resources;

  description;

  link = new Link();

  ipAddress;

  updateFromJson(json) {
    this.eventTime = json.eventTime;
    this.eventName = json.eventName;
    this.ipAddress = json.ipAddress;
    if (json.description) {
      this.description = json.description;
    }
    if (json.account) {
      this.account.id = json.account.id;
      this.account.name = json.account.name;
      this.account.email = json.account.email;
      this.account.domain = json.account.domain;
      this.account.userType = json.account.userType;
    } else {
      this.account = {};
    }
    if (json.resources) {
      this.resources = json.resources.map(resource => this.updateResourcesFromJson(resource));
    }
    if (json.link) {
      this.link.param = json.link.param;
      this.link.path = json.link.path;
    } else {
      this.link = {};
    }
  }

  updateResourcesFromJson(json) {
    const resource = new Resources();
    resource.type = json.type;
    resource.content = json.content;
    return resource;
  }
}

export default AuditLog;
